import { useQuery } from "@apollo/client";
import { GET_LEAVING_QUESTIONNAIRES } from "./gql";
import { Container, Typography } from "@mui/material";
import LeavingQuestionnaireEntry from "./LeavingQuestionnaireEntry";
import type { LeavingQuestionnaireListItem } from "../../../utils/Types/LeavingQuestionnaireType";
import Grid from "@mui/material/Grid2";
import LoadingCircle from "../../../components/LoadingCircle";
import BasicLayout from "../../../components/layout/BasicLayout";
import ErrorLayout from "../../../components/layout/ErrorLayout";

const LeavingQuestionnairesOverview = () => {
  const {
    data: questionnairesData,
    loading: questionnairesLoading,
    error: questionnaireError,
  } = useQuery(GET_LEAVING_QUESTIONNAIRES);

  if (questionnairesLoading || !questionnairesData) return <LoadingCircle />;
  if (questionnaireError)
    return <ErrorLayout errorMsg={questionnaireError.message || ""} />;

  return (
    <BasicLayout>
      <Container maxWidth="sm">
        <Grid container spacing={2}>
          <Grid>
            <Typography variant="h2">Výstupní dotazníky</Typography>
          </Grid>
          {questionnairesData.leavingQuestionnaires?.length === 0 && (
            <Grid size={{ xs: 12 }}>
              <Typography variant="body1">
                Nemáte žádné aktivní výstupní dotazníky.
              </Typography>
            </Grid>
          )}
          {[...(questionnairesData.leavingQuestionnaires || [])]
            .map((item: LeavingQuestionnaireListItem) => (
              <Grid key={item.id} size={{ xs: 12 }}>
                <LeavingQuestionnaireEntry questionnaire={item} />
              </Grid>
            ))}
        </Grid>
      </Container>
    </BasicLayout>
  );
};

export default LeavingQuestionnairesOverview;
